import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AllPersonnelContext } from "repository/stores/dashboard/personnel/personnel-all-provider";
import styles from "./dialogues-edit-interested-lecturing-styles";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton,
} from "@material-ui/core";
import SubjectIcon from "@material-ui/icons/Subject";
import DeleteIcon from "@material-ui/icons/Delete";
import { withSnackbar } from "notistack";
import { toast } from "react-toastify";
import Popup from "components/popup";

//Actions
import { updateNewPersonnel } from "repository/actions/data/dashboard/personnel";
const useStyles = makeStyles(styles);

function EditLecturingInterestsDialogue(props) {
  const classes = useStyles();

  const { setClose, isOpen, personId, person, setInterestedLecturing, user } =
    props;
  const {personnel, setPersonnel} = React.useContext(AllPersonnelContext);

  const [lecturingInterests, setLecturingInterests] = React.useState([]);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [newInterest, setNewInterest] = React.useState(null);
  const [newInterestError, setNewInterestError] = React.useState(null);

  useEffect(() => {
    if (person && person != null) {
      if (person.interestedInLecturing) {
        setLecturingInterests(person.interestedInLecturing);
      }
    }
  }, [person]);

  const handleAddNewInterest = () => {
    if (newInterest == null) {
      setNewInterestError("Cannot have an empty interest");
    } else {
      let newLectuingInterests = [newInterest].concat(lecturingInterests);
      setLecturingInterests(newLectuingInterests);
      setNewInterestError(null);
    }
  };

  const handleSaveLecturingInterests = () => {
    if (user && user != null) {
      let patchData = { ...person, interestedInLecturing: lecturingInterests };
      updateNewPersonnel( personId, patchData, user.idToken)
        .then((result) => {
          toast.success(
            `Lecturing interests for ${person.firstName} ${person.lastName} updated`
          );
          setInterestedLecturing(lecturingInterests);
          handleClose();
          setSaveLoading(false);
        })
        .catch((error) => {
          toast.error(
            "Oops! Something went wrong. Check that you have the correct information."
          );
          toast.dark(error.message);
          setSaveLoading(false);
        });
    }
  };

  const onPressedDeleteInterests = (index) => {
    if (lecturingInterests.length > index) {
      let newLecturingInterests = [];

      for (let [i, e] of lecturingInterests.entries()) {
        if (i != index) {
          newLecturingInterests.push(e);
        }
      }
      setLecturingInterests(newLecturingInterests);
    }
  };

  const handleClose = () => {
    setClose();
  };

  return (
    <Popup
      title="Lecturing Interests"
      subtitle="Edit the lecturing interests for this person"
      isOpen={isOpen}
      handleCancel={() => handleClose()}
      handleAction={() => handleSaveLecturingInterests()}
      actionButtonTitle="Save"
      disabled={saveLoading}
      content={
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <FormControl className={classes.formControl}>
                  <TextField
                    placeholder={"Ex: Human Resources"}
                    disabled={saveLoading}
                    required
                    helperText={newInterestError}
                    error={newInterestError != null}
                    label="New Lecturing Interest"
                    value={newInterest}
                    onChange={(event) => setNewInterest(event.target.value)}
                    margin="normal"
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={() => handleAddNewInterest()}
                  >
                    Add Interest
                  </Button>
                </FormControl>
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <List className={classes.root}>
                  {lecturingInterests.map((entry, index) => {
                    return (
                      <ListItem key={index}>
                        <ListItemAvatar>
                          <Avatar>
                            <SubjectIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Grid container spacing={3}>
                              <Grid item xs={9}>
                                {entry}
                              </Grid>
                              <Grid item xs={3}>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={(event) => {
                                    onPressedDeleteInterests(index);
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
}

export default withSnackbar(EditLecturingInterestsDialogue);
